import React from "react";
import { Box, Paper, Typography } from "@mui/material";

export default function SectionCard({ title, subtitle, children, right }) {
  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid rgba(2,32,53,0.10)",
        borderRadius: 3,
        p: 2,
        mb: 2,
        background: "#fff",
      }}
    >
      {(title || subtitle || right) ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 2,
            mb: 1.5,
          }}
        >
          <Box>
            {title ? (
              <Typography sx={{ fontWeight: 900, fontSize: 16 }}>
                {title}
              </Typography>
            ) : null}

            {subtitle ? (
              <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>

          {right ? <Box>{right}</Box> : null}
        </Box>
      ) : null}

      {children}
    </Paper>
  );
}